<template>
  <div class="home-page">
    <!-- <div class="page-banner">
      <img class="banner-image_bg" src="../assets/icon_bg_.jpg" />
      <img class="banner-image" src="../assets/icon_home_banner.png" />
      <img class="banner-image" src="../assets/home/icon_home_banner_top.png" />
      <div class="banner-action">
        <div class="action-item">
          <span class="action-understand" @click="linkPath('/bike')">了解更多</span>
          <span class="action-make" @click="linkPath('/reservation')">预约试驾</span>
        </div>
      </div>
    </div> -->
    <div class="banner-wrap">
      <el-carousel height="100vh">
        <el-carousel-item>
          <div class="page-banner">
            <!-- <img class="banner-image_bg" src="../assets/icon_bg_.jpg" /> -->
            <img class="banner-image_bg" src="../assets/icon_bg_.jpg" />
            <!-- <img class="banner-image" src="../assets/icon_home_banner.png" /> -->
            <!-- <img class="banner-image" src="../assets/home/icon_home_banner_top.png" /> -->
            <img class="banner-image" src="../assets/home/icon_home_banner_002.png" />
            <div class="banner-action">
              <div class="action-item">
                <span class="action-understand" @click="linkPath('bike.html')">了解更多</span>
                <span class="action-make" @click="linkPath('reservation.html')">预约试驾</span>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="page-banner">
            <img class="banner-image_bg" src="../assets/icon_bg_.jpg" />
            <img class="banner-image banner-image2" src="../assets/icon_home_banner.png" />
            <!-- <img class="banner-image" src="../assets/home/icon_home_banner_top.png" /> -->
            <div class="banner-action">
              <div class="action-item">
                <span class="action-understand" @click="linkPath('types.html')">了解更多</span>
                <span class="action-make" @click="linkPath('reservation.html')">预约试驾</span>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- <div class="home-model">
      <div class="feature-domain">
        <div class="domain-media domain-media-sp" v-if="domainType == '1'">
          <img class="domain-image" src="../assets/types/icon_car_type_002.png" />
          <img class="domain-image2" src="../assets/home/icon_car_type_003.png" />
        </div>
        <div class="domain-media" v-if="domainType == '2'">
          <img class="domain-image" src="../assets/types/icon_car_type_002.bak.png" />
        </div>
        <div class="domain-media domain-media2" v-if="domainType == '3'">
          <img class="domain-image" src="../assets/types/icon_car_type_001.bak.png" />
        </div>

        <div class="domain-left" @click="leftDomain">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="domain-right" @click="rightDomain">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div> -->

    <div class="home-about">
      <div class="about-title">关于 TASOW 探所</div>
      <div class="about-trips"><b>T</b>o <b>A</b>ccelerate the advent of <b>S</b>ustainable and <b>O</b>pen <b>W</b>orld.</div>
      <div class="about-trips">加速可持续发展和开放世界的到来。</div>
      <div class="about-image">
        <img class="image-url" src="../assets/home/icon_home_about_01.png" />
      </div>
    </div>

    <div class="home-service">
      <div class="service-title">
        探所购车与服务
      </div>
      <div class="service-trips">
        每一家探所空间都设在城市核心商圈，方便您的到来。
      </div>
      <div class="service-items">
        <div class="service-item">
          <img class="service-image" src="../assets/home/icon_service_001.png" />
          <div class="service-footer">
            <span class="service-img-title">探所空间</span>
            <div class="service-trips-more">
              <span class="trips-txt">定义两轮电动高端门店体验</span>
              <!-- <span class="service-more" @click="linkPath('/store')">
                了解更多
                <i class="el-icon-arrow-right"></i>
              </span> -->
            </div>
          </div>
        </div>
        <div class="service-item">
          <div class="image-wrap">
            <img class="service-image service-image2" src="../assets/home/icon_service_001.png" />
            <img class="service-image-seat" src="../assets/icon_fuwu_2.png" />
          </div>
          <div class="service-footer">
            <span class="service-img-title">探所服务</span>
            <div class="service-trips-more">
              <span class="trips-txt">省心、上门、免费代步车</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="home-footer">
      <home-reservation />

      <!-- <footer-common /> -->
    </div>

    <div class="home-seat-footer">
      <span class="version">联系电话：010-53518150</span>
      <span class="version">客服电话：400-004-2049</span>
      <span class="version" @click="openPath('privacy.html')">隐私政策</span>
      <span class="version" @click="openPathbak()">沪ICP备2024096717号</span>
    </div>


    <div class="pre-load">
      <img src="../assets/types/icon_car_type_002.bak.png" />
      <img src="../assets/types/icon_car_type_001.bak.png" />
    </div>
  </div>
</template>

<script>
import HomeReservation from './homeReservation';
// import FooterCommon from '../components/footerCommon';
import { filingsUrl } from '../constant.js';

export default {
  components: {
    HomeReservation,
    // FooterCommon,
  },
  data() {
    return {
      domainType: '1'
    }
  },
  methods: {
    // updateAgree() {
    //   this.isAgree = !this.isAgree;
    // }
    leftDomain() {
      const index = +this.domainType - 1;
      if (index === 0) {
        this.domainType = '3';
      } else {
        this.domainType = index;
      }
    },
    rightDomain() {
      const index = +this.domainType + 1;
      if (index === 4) {
        this.domainType = '1';
      } else {
        this.domainType = index;
      }
    },
    linkPath(path) {
      location.href = path;
    },
    openPath(path) {
      window.open(path, '_blank');
    },
    openPathbak() {
      window.open(filingsUrl, '_blank');
    }
  }
}
</script>

<style lang="less" scoped>
.home-page {
  /deep/.el-carousel__arrow {
    top: 45%;
    background: transparent;
    .el-icon-arrow-left, .el-icon-arrow-right{
      color: #333;
      font-size: 36px;
    }
  }
  /deep/.el-carousel__arrow--left {
    // opacity: 0;
  }
  /deep/.el-carousel__arrow--right {
    // opacity: 0;
  }
  /deep/.el-carousel__indicators {
    opacity: 0;
  }
  .page-banner {
    position: relative;
    font-size: 0;
    .banner-image_bg {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      // height: calc(100vh - 50px);
      // height: 100vh;
      // min-height: 580px;
      z-index: 1;
    }
    .banner-image {
      position: relative;
      z-index: 2;
      width: 100%;
      // height: calc(100vh - 50px);
      // height: 100vh;
      // min-height: 580px;
    }
    .banner-image2 {
      width: 92%;
      margin: 0 auto;
      height: auto;
    }
    .banner-action {
      position: absolute;
      top: 60%;
      left: 11%;
      z-index: 2;
      // .action-title {
      //   padding-bottom: 20%;
      //   font-size: 80px;
      //   color: #1A1A1A;
      //   .title-1 {
      //     font-weight: 300;
      //   }
      //   .title-2 {
      //     font-weight: 400;
      //   }
      // }
      .action-item {
        display: flex;
        .action-understand {
          width: 124px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          background: #222222;
          font-size: 19px;
          color: #F4F4F4;
          border-radius: 24px;
          cursor: pointer;
          margin-right: 18px;
        }
        .action-make {
          width: 122px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: #222222;
          font-size: 19px;
          border-radius: 24px;
          cursor: pointer;
          border: 1px solid #222222;
        }
      }
    }
  }
  .home-model {
    padding: 0 8.12%;
    background-image: linear-gradient(118deg, #FFF1E1 0%, rgba(255,255,255,0.10) 100%);
    background-image: linear-gradient(118deg, rgba(255, 241, 225, 0.95) 0%, rgba(255,255,255,0.10) 100%);
    // background-image: linear-gradient(118deg, rgba(255,244,233,0.75) 0%, rgba(255,255,255,0.10) 100%);
    .model-title {
      height: 0;
      transform: translateY(20px);
      padding: 12px;
      font-size: 30px;
      color: #222222;
      letter-spacing: 12px;
      margin-left: 12px;
      text-align: center;
      font-weight: 500;
    }

    .feature-domain {
      position: relative;
      .domain-media {
        border-radius: 14px;
        overflow: hidden;
        .domain-image {
          width: 100%;
        }
        &.domain-media-sp {
          position: relative;
          .domain-image {
            opacity: 0;
          }
          .domain-image2 {
            position: absolute;
            left: 25%;
            top: 25%;
            width: 50%;
            z-index: 9;
          }
        }
      }
      .domain-left {
        position: absolute;
        top: 50%;
        z-index: 999;
        color: #333;
        height: 100px;
        width: 100px;
        margin-top: -70px;
        font-size: 36px;
        cursor: pointer;
      }
      .domain-right {
        position: absolute;
        top: 50%;
        right: 0;
        z-index: 999;
        color: #333;
        height: 100px;
        width: 100px;
        margin-top: -70px;
        font-size: 36px;
        cursor: pointer;
      }
    }
  }

  .home-about {
    padding: 0 8.12%;
    background-image: linear-gradient(118deg, #FFF1E1 0%, rgba(255,255,255,0.40) 100%);
    padding-top: 40px;
    .about-title {
      // padding-bottom: 8px;
      // line-height: 32px;
      // text-align: center;
      // color: #222222;
      // font-size: 32px;
      // font-weight: 500;
      // letter-spacing: 4px;
      // margin-left: 4px;
      display: block;
      padding-bottom: 8px;
      font-size: 34px;
      color: #222222;
      text-align: center;
      line-height: 32px;
      font-weight: 500;
    }
    .about-trips {
      // padding-top: 12px;
      // line-height: 24px;
      // text-align: center;
      // color: #222222;
      // font-size: 16px;

      display: block;
      padding-top: 10px;
      font-size: 20px;
      color: #333;
      text-align: center;
      line-height:24px;
    }
    .about-image {
      padding-top: 20px;
      padding-bottom: 20px;
      text-align: center;
      .image-url {
        width: 98%;
      }
    }
  }

  .home-service {
    padding: 6% 11% 10% 11%;
    .service-title {
      padding-bottom: 12px;
      line-height: 60px;
      text-align: center;
      color: #222222;
      font-size: 32px;
      font-weight: 500;
      letter-spacing: 4px;
      margin-left: 4px;
    }
    .service-trips {
      line-height: 24px;
      text-align: center;
      color: #222222;
      font-size: 18px;
    }
    .service-items {
      display: flex;
      justify-content: space-between;
      padding-top: 40px;
      .image-wrap {
        position: relative;
      }
      .service-item {
        width: 48%;
        font-size: 0;
        background-image: linear-gradient(180deg, rgba(255,255,255,0.10) 15%, rgba(255,251,247,0.33) 31%, rgba(255,247,239,0.56) 49%, rgba(255,244,233,0.75) 66%, rgba(255,242,228,0.89) 80%, rgba(255,241,225,0.97) 92%, #FFF1E1 100%);
        .service-image {
          width: 100%;
        }
        .service-image-seat {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
        .service-image2 {
          opacity: 0;
        }
        .service-footer {
          padding: 3% 20px;
          // background-image: linear-gradient(180deg, rgba(255,251,247,0.8) 0%, rgba(255,242,228,0.89) 60%, rgba(255,241,225,0.97) 92%, #FFF1E1 100%);
        }
        .service-img-title {
          display: block;
          font-size: 22px;
          padding-bottom: 18px;
          color: #606060;
        }
        .service-trips-more {
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          color: #606060;
          .service-more {
            font-size: 12px;
            color: #222222;
            cursor: pointer;
          }
        }
      }
    }
  }

  .home-footer {
    background-image: linear-gradient(0deg, rgba(255,255,255,0.10) 0%, rgba(255,251,247,0.33) 9%, rgba(255,247,239,0.56) 20%, rgba(255,244,233,0.75) 30%, rgba(255,242,228,0.89) 39%, rgba(255,241,225,0.97) 46%, #FFF1E1 51%);
    .footer-introduce {
      // padding: 0 11%;
      padding-top: 80px;
      display: flex;
      .introduce-image {
        width: 100%;
      }
      // justify-content: space-between;
      .introduce-txt {
        flex: 0 0 350px;
        display: flex;
        align-items: center;
        .txt-wrap {
          .txt-app {
            display: block;
            line-height: 46px;
            color: #000000;
            font-weight: 500;
            font-size: 32px;
            font-weight: 350;
          }
          .txt-trips {
            line-height: 32px;
          }
        }
      }
      .introduce-img {
        flex: 1;
        transform: translateX(15%);
        .img-link {
          width: 90%;
          margin: 0 auto;
        }
      }
    }
  }

  .home-seat-footer {
    position: relative;
    z-index: 9;
    width: 100%;
    padding: 0 11%;
    box-sizing: border-box;
    height: 46px;
    line-height: 46px;
    background: #222222;
    margin-top: -4px;
    text-align: left;
    color: #fff;
    font-size: 14px;
    text-align: center;
    .version {
      padding: 0 12px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
